export default __webpack_public_path__ + "static/media/g2022-11.01945a63.jpeg";